export default __webpack_public_path__ + "static/media/ming.7a15439f.jpg";